enum SpecialProc {
    DisableCache = 4
}

export default SpecialProc;